export const SLOTS_SYMBOLS = ["🍒", "🍊", "🍇", "🍋", "🍎", "🔔"];
